export default __webpack_public_path__ + "static/media/services_car_wash.4b77e723.svg";